// extracted by mini-css-extract-plugin
export default {"searchIcon":"table_searchIcon__6cKoc"};